import { kea } from 'kea'
import { actions } from './actions'
import { reducers } from './reducers'
import { selectors } from './selectors'

export const pricingSliderLogic = kea({
    actions,
    reducers,
    selectors,
})
